import { render, staticRenderFns } from "./CostOverview.vue?vue&type=template&id=44f8611e&scoped=true"
import script from "./CostOverview.vue?vue&type=script&lang=js"
export * from "./CostOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f8611e",
  null
  
)

export default component.exports